"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('file-word', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(8.000000, 4.000000)",
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M2,0 L22,0 L32,10 L32,38 C32,39.1045695 31.1045695,40 30,40 L2,40 C0.8954305,40 -5.67081481e-14,39.1045695 -5.68434189e-14,38 L-5.68434189e-14,2 C-5.69786896e-14,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    stroke: props.outStrokeColor,
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("polyline", {
    stroke: props.innerStrokeColor,
    strokeLinecap: props.strokeLinecap,
    points: "8.00833333 16 11.0083333 30 16.0083333 20 21.0083333 30 24.0083333 16"
  })))));
});

exports.default = _default;